import { comments } from '@/mocks/homeMangaData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">漫友热评</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">来自真实漫画爱好者的阅读体验分享</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {comments.map((item, i) => (
            <div key={i} className="bg-background-100 rounded-xl p-5 md:p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-accent-200 flex items-center justify-center text-accent-700 font-bold text-sm">
                  {item.avatar.charAt(0)}
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">{item.avatar}</p>
                  <p className="text-xs text-foreground-400">{item.date}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">"{item.content}"</p>
              <div className="flex items-center gap-2 flex-wrap">
                <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 font-medium">
                  {item.tag}
                </span>
                <span className="text-xs text-foreground-400">{item.manga}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}